import React, { useState } from "react";
import { HandoverTypeEnum } from "../types";
import ReadOnlyTextField from "../FormComponents/ReadOnlyTextField";
import FormFieldLayout from "../FormComponents/FormFieldLayout";
import { Heading } from "@origin-digital/ods-core";
import { ServiceTypeEnum } from "src/components/Premises/types";
import { format } from "date-fns";
import { handoverTypeToLabelMap } from "./helper";
import { CloseTransferWarningModalMessageType } from "./types";
import { CloseTransferWarningModal } from "./CloseTransferWarningModal";

export const mapServiceTypeToHeading = {
  [ServiceTypeEnum.ELECTRICITY]: "Electricity",
  [ServiceTypeEnum.GAS]: "Gas",
  [ServiceTypeEnum.INTERNET]: "INTERNET",
};

// TODO may consider to use CloseTransferWarningDialogProvider instead of CloseTransferWarningModal

export const CTReadOnlyServiceSection = ({
  handoverType,
  isOnlyOneServiceType,
  serviceType,
  preferDate,
  onAction,
  onCancel,
}: {
  handoverType: HandoverTypeEnum;
  isOnlyOneServiceType: boolean;
  serviceType: ServiceTypeEnum;
  preferDate: Date | null;
  onAction: () => void;
  onCancel: () => void;
}) => {
  const [openWarningModal, setOpenWarningModal] = useState(false);

  return (
    <>
      <FormFieldLayout multipleFields={!isOnlyOneServiceType}>
        {!isOnlyOneServiceType && (
          <Heading variant="h4">{mapServiceTypeToHeading[serviceType]}</Heading>
        )}
        <ReadOnlyTextField
          withAction={false}
          onAction={() => setOpenWarningModal(true)}
          onCancel={onCancel}
          label={`Preferred date to ${handoverTypeToLabelMap[handoverType]}`}
          value={preferDate ? format(preferDate, "dd/MM/yyyy") : "00/00/0000"}
        />
      </FormFieldLayout>
      {/* Warning Modal */}
      <CloseTransferWarningModal
        open={openWarningModal}
        setOpen={setOpenWarningModal}
        onUpdate={onAction}
        warningMessageType={CloseTransferWarningModalMessageType.PROCESSED}
      />
      {/* End Warning Modal */}
    </>
  );
};
